module.exports = __webpack_public_path__ + "img/policeman.0a32cb1b.jpg";